import type { DelayPair, PresetDef, PresetId } from '../lib/types';
import { delayPairLabel } from '../lib/delay';

export const COVER_FLASH_DELAY: DelayPair = [1, 100]; // 10ms
export const COVER_HOLD_DELAY: DelayPair = [999, 1]; // 999s
export const COVER_SOFT_FLASH_DELAY: DelayPair = [20, 100]; // 200ms
export const PSEUDO_DELAY: DelayPair = [1000, 1000]; // 1s

export const MIN_DURATION_MS = 10;
export const DEFAULT_DURATION_MS = 1000;
export const DEFAULT_SCALE = 1;
export const DEFAULT_LOOP = 0;

export const PRESETS: Record<PresetId, PresetDef> = {
  pseudo_static: {
    id: 'pseudo_static',
    label: '伪静态（双相同帧，防闪）',
    desc: `两帧同画面；delay 各 ${delayPairLabel(PSEUDO_DELAY)}；loop=0。无封面切换，最不易闪。`,
    delays: [PSEUDO_DELAY, PSEUDO_DELAY],
    loop: 0,
    requireCover: false,
    tag: '_pseudo',
  },
  cover_reveal: {
    id: 'cover_reveal',
    label: '封面伪装 → 打开后切内容（推荐）',
    desc: `帧0=${delayPairLabel(COVER_FLASH_DELAY)} 封面，帧1=${delayPairLabel(COVER_HOLD_DELAY)} 内容；loop=1。勿用纯黑封面。`,
    delays: [COVER_FLASH_DELAY, COVER_HOLD_DELAY],
    loop: 1,
    requireCover: true,
    tag: '_cover',
  },
  cover_reveal_soft: {
    id: 'cover_reveal_soft',
    label: '封面伪装（柔和，200ms 过渡）',
    desc: `帧0=${delayPairLabel(COVER_SOFT_FLASH_DELAY)}，帧1=${delayPairLabel(COVER_HOLD_DELAY)}；loop=1。`,
    delays: [COVER_SOFT_FLASH_DELAY, COVER_HOLD_DELAY],
    loop: 1,
    requireCover: true,
    tag: '_cover_soft',
  },
  manual: {
    id: 'manual',
    label: '手动（自定义 delay / loop）',
    desc: '可填 ms 或 num/den（如 1/100、999/1）。loop=0 为无限循环。',
    delays: null,
    loop: null,
    requireCover: false,
    tag: '_manual',
  },
};

export const PRESET_ORDER: PresetId[] = [
  'pseudo_static',
  'cover_reveal',
  'cover_reveal_soft',
  'manual',
];
